import { render, staticRenderFns } from "./AttachedAction.vue?vue&type=template&id=2f4ec519"
import script from "./AttachedAction.vue?vue&type=script&lang=js"
export * from "./AttachedAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports